import search from '@jetbrains/icons/search.svg'
import type {ContainerProps, InputSpecificProps} from '@jetbrains/ring-ui/components/input/input'
import Input, {Size} from '@jetbrains/ring-ui/components/input/input'
import classNames from 'classnames'
import * as React from 'react'
import type {SyntheticEvent} from 'react'

import styles from './Search.css'

type Props = Omit<ContainerProps<InputSpecificProps>, 'onClear'> & {
  forwardedRef?: React.Ref<HTMLInputElement>
  onClear?: (event: SyntheticEvent) => void
}

function Search({className, forwardedRef, onClear, onKeyDown, value, ...restProps}: Props) {
  const handleKeyDown = React.useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Escape') {
        e.currentTarget.blur()
        onClear?.(e)
      } else {
        onKeyDown != null ? onKeyDown(e) : null
      }
    },
    [onKeyDown, onClear],
  )
  return (
    <Input
      icon={search}
      inputRef={forwardedRef}
      className={classNames(className, styles.input)}
      onClear={onClear}
      size={Size.AUTO}
      value={value}
      data-test-agents-sidebar-search
      autoComplete="off"
      onKeyDown={handleKeyDown}
      {...restProps}
    />
  )
}

export default React.memo(Search)
